/**
 * The CBSE / NCERT CT & AI course's build-time switch (docs/cbse-ncert-ai-ct-plan.md §5b).
 *
 * Everything for the course lives in this folder: its pages, components, API
 * slice and styles. Off (the default, and production until it is switched on
 * there) adds no route and no sidebar entry; the server's CBSE_NCERT_AI_ENABLED
 * refuses its API either way. Platform code never imports from this folder
 * except to mount it behind this flag.
 *
 * Read through `?.` like thinkboard/flags.ts: under Jest `import.meta` has no `env`.
 */
const env = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env;

export const CBSE_NCERT_AI_ENABLED = env?.VITE_CBSE_NCERT_AI_ENABLED === "true";
